import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TranslatePageService {
    currentLanguage = this.getCurrentLanguage();

    @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

    public useLanguage=(language: string) => {
        this.currentLanguage = language; 
        this.eventEmitter.emit(language);
    }

   public getEmittedValue =() =>{
        return this.eventEmitter;
    }

    private getCurrentLanguage() {
       let language :string = 'en-US';
        if (navigator.languages && navigator.languages.length) {
            language = navigator.languages[0];
        } else {
            const preferredLanguages = navigator.languages;
            if (preferredLanguages && preferredLanguages.length > 0) {
                language = preferredLanguages[0];
                if (preferredLanguages.length > 1) {
                    language = preferredLanguages[0] || preferredLanguages[1];
                }
            } else {
                language = navigator.language || 'en-US';
            }
        }
        return language;
    }
}
